import {
  SUCCESS,
  FAIL,
  GET_CHECKLISTS,
  GET_CHECKLISTS_PAGINATED,
  GET_CHECKLIST_ID,
  GET_ESCALATION_PERSONS_LIST,
  GET_CHECKLISTS_REPORT,
  CLEAR_CHECKLISTS_REPORT,
  GET_CHECKLIST_DETAILS,
} from "../action_types";

const STATE_INIT = {
  isLoading: false,
  checklists: [],
  checklistsPaginated: {
    data: [],
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    itemsPerPage: 10,
  },
  checklistDetails: [],
  escalationPersons: [],
  isPersonsLoading: true,
  isDetailsLoading: true,
  isReportsLoading: true,
  reportsData: {},
  error: {},
  loading: false,
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_CHECKLISTS:
      return { ...state, isLoading: true };
    case `${GET_CHECKLISTS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        checklists: [...payload],
      };
    case `${GET_CHECKLISTS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_CHECKLISTS_PAGINATED:
      return { ...state, isLoading: true };
    case `${GET_CHECKLISTS_PAGINATED}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        checklistsPaginated: {
          data: payload.data || [],
          totalItems: payload.totalItems || 0,
          totalPages: payload.totalPages || 0,
          currentPage: payload.currentPage || 1,
          itemsPerPage: payload.itemsPerPage || 10,
        },
      };
    case `${GET_CHECKLISTS_PAGINATED}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_CHECKLIST_ID:
      return { ...state, isDetailsLoading: true };
    case `${GET_CHECKLIST_ID}_${SUCCESS}`:
      return {
        ...state,
        isDetailsLoading: false,
        checklistDetails: [...payload],
      };
    case `${GET_CHECKLIST_ID}_${FAIL}`:
      return { ...state, isDetailsLoading: false, error: { ...payload } };

    case GET_ESCALATION_PERSONS_LIST:
      return { ...state, isPersonsLoading: true };
    case `${GET_ESCALATION_PERSONS_LIST}_${SUCCESS}`:
      return {
        ...state,
        isPersonsLoading: false,
        escalationPersons: [...payload],
      };
    case `${GET_ESCALATION_PERSONS_LIST}_${FAIL}`:
      return { ...state, isPersonsLoading: false, error: { ...payload } };

    case GET_CHECKLISTS_REPORT:
      return { ...state, isReportsLoading: true };
    case `${GET_CHECKLISTS_REPORT}_${SUCCESS}`:
      return {
        ...state,
        isReportsLoading: false,
        reportsData: payload || [],
      };
    case `${GET_CHECKLISTS_REPORT}_${FAIL}`:
      return { ...state, isReportsLoading: false, error: { ...payload } };
    case CLEAR_CHECKLISTS_REPORT:
      return {
        ...state,
        reportsData: {},
      };

    default:
      return state;
  }
};
